export default "__VITE_ASSET__D1A$QO_7__"